import type { McpChatWidgetProps } from './interfaces/mcpChatWidgetProps';
import { useWidgetConfigRuntime } from './runtime/useWidgetConfigRuntime';
import { useWidgetConversationRuntime } from './runtime/useWidgetConversationRuntime';
import { useWidgetRuntime } from './runtime/useWidgetRuntime';
import { useWidgetSessionRuntime } from './runtime/useWidgetSessionRuntime';
import type { McpWidgetRuntimeApi } from './runtime/types';

export function useMcpWidgetRuntime(props: McpChatWidgetProps): McpWidgetRuntimeApi {
  const { shadow } = props;
  const runtime = useWidgetRuntime();
  const configRuntime = useWidgetConfigRuntime({
    props,
    refs: runtime.refs,
    closeMcpSession: runtime.closeMcpSession,
    fetchAnonymousToken: runtime.fetchAnonymousToken,
  });
  const sessionRuntime = useWidgetSessionRuntime({
    props,
    shadow,
    refs: runtime.refs,
    closeMcpSession: runtime.closeMcpSession,
    fetchAnonymousToken: runtime.fetchAnonymousToken,
  });
  const conversationRuntime = useWidgetConversationRuntime({
    refs: runtime.refs,
    performHealthCheck: configRuntime.performHealthCheck,
    seedGreeting: configRuntime.seedGreeting,
  });

  return {
    orchestratorRef: sessionRuntime.orchestratorRef,
    getMcpReadyPromise: sessionRuntime.getMcpReadyPromise,
    syncAttributesToConfig: configRuntime.syncAttributesToConfig,
    seedGreeting: configRuntime.seedGreeting,
    updateGreetingForLanguage: configRuntime.updateGreetingForLanguage,
    checkHealth: configRuntime.checkHealth,
    initMcpSession: sessionRuntime.initMcpSession,
    handleSessionExpiry: sessionRuntime.handleSessionExpiry,
    closeMcpSession: sessionRuntime.closeMcpSession,
    resetTransientState: sessionRuntime.resetTransientState,
    handleDrop: conversationRuntime.handleDrop,
    resetConversation: conversationRuntime.resetConversation,
    refreshConfig: conversationRuntime.refreshConfig,
    loadConversation: conversationRuntime.loadConversation,
    toggleDrivingMode: sessionRuntime.toggleDrivingMode,
    clearServerAuthOverride: sessionRuntime.clearServerAuthOverride,
  };
}
